(function(){
  const lightbox = document.getElementById('simpleLightbox');
  const lightboxImg = document.getElementById('lightboxImage');
  const closeBtn = lightbox.querySelector('.lightbox-close');
  const prevBtn = lightbox.querySelector('.lightbox-prev');
  const nextBtn = lightbox.querySelector('.lightbox-next');
  const bg = lightbox.querySelector('.lightbox-background');

  let images = [];
  let index = 0;

  function openLightbox(i){
    images = Array.from(document.querySelectorAll('.archives-item img'));
    index = i;
    lightboxImg.src = images[index].dataset.full || images[index].src;
    lightbox.classList.add('active');
  }

  function closeLightbox(){
    lightbox.classList.remove('active');
    lightboxImg.src = '';
  }

  function showNext(){
    index = (index + 1) % images.length;
    lightboxImg.src = images[index].dataset.full || images[index].src;
  }

  function showPrev(){
    index = (index - 1 + images.length) % images.length;
    lightboxImg.src = images[index].dataset.full || images[index].src;
  }

  // Open image click
  document.addEventListener('click', function(e){
    const img = e.target.closest('.archives-item img');
    if(!img) return;

    const all = Array.from(document.querySelectorAll('.archives-item img'));
    const i = all.indexOf(img);
    if(i === -1) return;

    e.preventDefault();
    openLightbox(i);
  });

  // Close lightbox
  closeBtn.addEventListener('click', closeLightbox);
  bg.addEventListener('click', closeLightbox);
  document.addEventListener('keydown', function(e){
    if(!lightbox.classList.contains('active')) return;
    if(e.key === 'Escape') closeLightbox();
    if(e.key === 'ArrowRight') showNext();
    if(e.key === 'ArrowLeft') showPrev();
  });

  // Arrow buttons
  nextBtn.addEventListener('click', showNext);
  prevBtn.addEventListener('click', showPrev);
})();
